const DOCUMENT = 'POOLS_BREAKDOWN_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: payload => ({ type: actions.LOAD, payload }),
  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),
  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
};

export default actions;
